export default __webpack_public_path__ + "static/media/GHSI Guideline for the Selection Process of External Auditor.20f9731e.pdf";